// Word Wheel puzzles for Spanish.
// letters: the seven tiles. words: common words to find (shown in the count). extra: other valid words, accepted as bonus.
// Checked against a spelling dictionary, so no word needs to be verified while playing.

export const WHEEL_ES = [
    {
        letters: 'isniulo',
        words: 'ilusión lino liso los nos nulo sin sino sol son unió uno unos uso',
        extra: 'iluso ión linio lis luso lío líos nis nulos olí oís sil silo uníos',
    },
    {
        letters: 'odorpei',
        words: 'dio diré ido odio oro oído oír pedir pedo pedí peor perdió perdí pero período pide pido pie pierdo poder podio podré por predio pro red rodeo río',
        extra: 'der dir dore dorio doro ero ideó iré odie oidor operó opio oreo oré peo peri pire piro pode poderío podo poro pío rdo reo reí reído rodio rodó roo ríe',
    },
    {
        letters: 'lijalme',
        words: 'allí elija ella leal lema leí leía lima llame mal mejilla miel mil milla mía',
        extra: 'aje ají jale jame leila lejía lela lija lila lié lle lía maje malí mea mela mella mié',
    },
    {
        letters: 'botilne',
        words: 'bien boletín bote botín lento leí león lino lote neto nieto noble noté telón tío',
        extra: 'bel bino ble bol boten etilo eón ión letón libe lito lié loe lío neo nito obtén olí tenlo tilo tino tole tonel íleon',
    },
    {
        letters: 'reggaan',
        words: 'agrega agregan arena era eran gana ganar gane gran negar negra rana área',
        extra: 'aran arenga ganaré ganga grana nea negara rae rea renga',
    },
    {
        letters: 'isemdac',
        words: 'así cae casi dame das decía demás des dice dices dime día días esa idea ideas media medias mes mesa mide mis misa más médica médicas mía sea seca',
        extra: 'aes ames amis ase cadí caes casé caí cea ceda cedas cedí cedía cesa cid cima cimas cisma cía cíe cíes dais decías decís deis dima dimas décima décimas esca ida idas maíces mea meas meca mecía meda medas medí mica micas mida midas mides mies mise mié mías sed seda sima ídem íes',
    },
    {
        letters: 'stulreo',
        words: 'eso esto euro euros les los lote lotes luto oler resto resultó reto retos rol ruso ser serlo sol soler suelo suelto suero sur tres tus uso útero',
        extra: 'ero estro loe lores losé luso lustre lustro oles oré ose reo reos ros rulo rulos rus rute sel seto solté solé sor sto surte terso tes teso tole tos tose toser trol trole troles tul ues uro uros usé úselo úteros',
    },
    {
        letters: 'gsreasu',
        words: 'auge era eras esa esas gas gases gruesa gruesas grúa ruega rusa rusas sea seas segura seguras ser será serás suegra sur surge usa usar usarse usas',
        extra: 'aes agur ares ase ases ges gres grúas gua güera rae rea reas ruge rus rúa sega segar segur sras sres suegras ues urea usaré usase usé',
    },
    {
        letters: 'ocptolm',
        words: 'colmo colo como complot coto loco lomo moto optó plomo poco polo tocó tomó topo',
        extra: 'col copo copto loc loto moco mol molo olmo oto pol pomo poto tpo',
    },
    {
        letters: 'raocren',
        words: 'acero arco cae caen caer carne caro carro cena cenar cero cerro corea corre correa corren crea crean crear crearon creo eco era eran nace nacer raro roca',
        extra: 'acné ano arce arcén arcón aro aron arre arreo cano careo carnero cea ceno cera cerna cerno cerra coa corean corear corra corran cráneo córnea encaró ero erra erro eón nao narró nea neo nro oca ocre ora oran orar orca orea oren orne oré rae rano rea renca rencor reno reo roa roce roer ron ronca roncar',
    },
    {
        letters: 'mabiarc',
        words: 'abra abrí acá ama amar arca aria arma barca cabra cama cambia cambiar cara caía cima cría iba ira mar marca mira miraba mía rabia rama rica rima',
        extra: 'abia abría amia baca barcia brama cabría cabía camba caria caí criaba criba cía maca marcia mica mir raba rabí ría ámbar',
    },
    {
        letters: 'etmaels',
        words: 'esa ese esmalte esta este las lee lees lema les mal mate mes mesa meta metales metas mete más sal sale sea tal tales tela tele tema temas teme',
        extra: 'aes ames ase ates até ele eles eme estela eta leas lemas lesa leste léase maese maltés mates mea meas mee mees mela mese meseta mesta metes salte sel seta sta tas telas teles temes tes tesa tesla',
    },
];